import { create } from 'zustand';

interface ApiConnectivityState {
  hasConnectionIssue: boolean;
  setHasConnectionIssue: (hasConnectionIssue: boolean) => void;
}

export const useApiConnectivityStore = create<ApiConnectivityState>((set, get) => ({
  hasConnectionIssue: false,
  setHasConnectionIssue: (hasConnectionIssue: boolean) => set({ hasConnectionIssue }),
}));
